module.exports = __webpack_public_path__ + "static/media/Icon_SW_Active.caa9b2ba.png";